export default __webpack_public_path__ + "static/media/over-status.8aa7a16d.svg";